import { BaseEntity } from '@core/entities/_extra';
import { Expose, Transform, Type } from 'class-transformer';
import { UserEntity } from '@core/entities/user.entity';
import { SafeUrl } from '@angular/platform-browser';

export class FaqEntity extends BaseEntity {
  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  title = '';

  category = 0;
  position = 0;

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  description = '';

  author = 0;

  @Type(() => FaqCategoryEntity)
  faqCategory: FaqCategoryEntity;

  @Type(() => UserEntity)
  user: UserEntity;

  // @Expose({ name: 'faq_image' })
  // @Type(() => FaqImage)
  // faqImage: FaqImage[];

  document: string;
  image: string;
  imageUrl: SafeUrl | string;

  constructor(init?: Partial<FaqEntity>) {
    super(init);
    this.initEntity(init);
  }

  // get imageUrl(): string {
  //   return this.image ? GenerateImageUrlWithToken(this.id, SectionType.FAQ) : null;
  // }
}

export class FaqCategoryEntity extends BaseEntity {
  @Expose({ name: 'category_title' })
  title = '';

  @Expose({ name: 'category_description' })
  description? = '';

  @Expose({ name: 'category_position' })
  position = 0;

  author = 0;

  constructor(init?: Partial<FaqCategoryEntity>) {
    super(init);
    this.initEntity(init);
  }
}

export class FaqImage {
  @Expose({ name: 'faq_id' })
  id: number;
  @Expose({ name: 'faq_image' })
  image: string;
  @Expose({ name: 'faq_document' })
  document: string;
}
